// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e957d298","732":"16a49c08"}[chunkId] + ".chunk.js";
};